export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8169.6555a31d.jpg";